// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__ooSU7","icon":"search_icon__12TGY","input":"search_input__WgDpQ","button":"search_button__2IOSO"};